import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A7OPCVMClientPortfoliosEdit } from "./edit";
import { A7OPCVMClientPortfoliosTable } from "./table";

export default function A7OPCVMClientPortfolios() {
  useEffect(() => {
    setDocumentTitle("Quantilia | OPCVM Portefeuilles");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A7OPCVMClientPortfoliosEdit />} />
      <Route index element={<A7OPCVMClientPortfoliosTable />} />
    </Routes>
  );
}
